import featurePlaylistConfig from './feature/playlist'

const playlistsConfig = {
  sessionLimit: featurePlaylistConfig.sessionLimit,
  playlistLimit: featurePlaylistConfig.playlistLimit,
}

export default playlistsConfig
